
export const DomainWebPath = {
  SIM  : 'https://sim-checkout.test2pay.com',
  UAT  : 'https://uat-checkout.test2pay.com',
  PROD : 'https://checkout.payby.com'
}

export const getRuntimeEnv = () => {
  const domain = location.host
  let env = 'SIM'
  Object.entries(DomainWebPath).forEach(([k, v]) => {
    if (v.indexOf(domain) > -1) {
      env = k
    }
  })
  return env
}
